$( document ).on('turbolinks:load', () => {
  $('#dte-daily-transferred-btn').on('click', () => {
    $('#document-table').addClass('d-none')
    $('.loader').fadeIn();
  })
})